import TabOptions from '../options';

export class Model {
  options = [];
  otherCondition = null;
  otherConditions = [];
}

import vocationalEvaluationOptionTypes from '@/utils/constants/vocationalEvaluationOptionTypes';

export class Tab {
  id = 'OnePartA';
  title = 'I.A';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    const options = model?.options || [];

    const primaryLanguage =
      options.find(
        (x) =>
          x?.type?.id === vocationalEvaluationOptionTypes.LenguajePrincipal &&
          x?.checked
      ) || null;

    const communicationTypes = options.filter(
      (x) =>
        x?.type?.id ===
          vocationalEvaluationOptionTypes.ModosComunicacionExpresionOral &&
        x?.checked
    );

    return {
      tab: this.id,
      primaryLanguageId: primaryLanguage?.id ?? null,
      otherLanguage: primaryLanguage?.isOther
        ? primaryLanguage?.other ?? null
        : null,
      communicationTypeIds: communicationTypes.map((x) => x.id),
      peiId: model.peiId,
      reportDate: model.reportDate,
      otherConditions: (model?.otherConditions ?? []).map((x) => ({
        id: x?.id,
        other: x?.other ?? null,
      })),
    };
  };
}

export default new Tab();
